import { render, staticRenderFns } from "./Verifikasiuser.vue?vue&type=template&id=39530bcc"
import script from "./Verifikasiuser.vue?vue&type=script&lang=js"
export * from "./Verifikasiuser.vue?vue&type=script&lang=js"
import style0 from "./Verifikasiuser.vue?vue&type=style&index=0&id=39530bcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports